module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_home_color_red-56cd8eabd60e519d4eeeda488011dff7.svg";